
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/visualize/sol2uml",
      function () {
        return require("private-next-pages/visualize/sol2uml.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/visualize/sol2uml"])
      });
    }
  